import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { MRSService } from 'src/app/appServices/ControlServices/mrs';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ParticipateInRapidiOptions, actionOptions, dateTypeOptions } from 'src/app/appWeb/shared/shared';
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-mrs',
  templateUrl: './mrs.component.html',
  styleUrls: ['./mrs.component.scss']
})
export class MrsComponent implements OnInit {
  FileSaver = FileSaver;
  exportExcelLoader: boolean = false;

  //Table Varibales
  totalRecords = 0;
  pageNumber = 1;
  rows = 15;
  sortOrder = 'DESC';
  sortCol = '';
  filterVal = '';
  cols: any;

  UId: any;
  RoleName: any;
  roleForFacility: boolean = false;
  minDate: any;
  SearchLoader: boolean = false;

  selectedFacility: any = [];
  selectedSystem: any = 0;
  selectedRegional: any = 0;
  selectedQPS: any = [];
  selectedDateType: any = '';
  selectedActionType: any = [];
  selectedParticipatesInRapidi: any = [];
  ParticipateInRapidiOptions = ParticipateInRapidiOptions;
  dateTypeOptions = dateTypeOptions;
  actionOptions = actionOptions;
  event: any;
  SelectListFilter: any;
  SelectFacilityData: any = [];
  SelectSystemData: any = [];
  SelectRegionData: any = [];
  SelectQPSData: any = [];
  showProgressSpinner: boolean = false;
  private subscription: Subscription[] = [];
  txtEndDate: Date = new Date();
  txtStartDate: Date = new Date();
  data = {};
  selectedFilterType: any;
  txtStartDateErrorBool: any;
  dateRangeBool: any;
  txtEndDateErrorBool: any;
  mrsData: any;
  txtSpecificDate: any;
  txtSpecificDateErrorBool: boolean = false;
  selectFacilityPIOptions: any;
  dataForExcelBool: boolean = false;
  selectedTypeBool: boolean = false;
  textStrtColorBool: boolean = false;
  textEndColorBool: boolean = false;
  clearSearchBool: boolean = false;
  datePipe = new DatePipe('en-US');


  constructor(private analyzeService: AnalyzeService, private helperService: HelperService, private authService: AuthService,
    private messageService: MessageService, private mrsService: MRSService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    this.minDate = this.analyzeService.CalanderDateRangeSelection(true);
    this.GetAllData('facility');
    this.GetMRSFollowUpReport();
  }


  GetAllData(req: any) {
    if ((this.SelectFacilityData.length == 0 && req == 'facility') ||
      (this.SelectSystemData.length == 0 && req == 'system') ||
      (this.SelectRegionData.length == 0 && req == 'regional') ||
      (this.SelectQPSData.length == 0 && req == 'qps')) {
      this.showProgressSpinner = true;
      let obj: any = {};
      if (req == 'facility') {
        obj.fieldName = 'facility';
        obj.value = 'facility';
      } else if (req == 'system') {
        obj.fieldName = 'ucd_ucl_key';
        obj.value = '42';
      } else if (req == 'qps') {
        obj.fieldName = 'qps';
        obj.value = 'qps';
      } else {
        obj.fieldName = 'ucd_ucl_key';
        obj.value = '43';
      }
      this.subscription.push(
        this.analyzeService.GetAllData(obj, this.RoleName, this.UId).subscribe({
          next: (res: any) => {
            if (res) {
              this.showProgressSpinner = false;
              if (req == 'facility') {
                this.SelectFacilityData = res.data;
                this.SelectListFilter = res.data;
              } else if (req == 'system') {
                this.SelectSystemData = res.data;
                this.SelectListFilter = res.data;
              } else if (req == 'qps') {
                this.SelectQPSData = res.data;
                this.SelectListFilter = res.data;
              } else {
                this.SelectRegionData = res.data;
                this.SelectListFilter = res.data;
              }
            }
          },
          error: (err: any) => { },
        })
      );
    }
  }

  OnChangeSystemFilter() {
    this.subscription.push(
      this.mrsService.GetFacilityBySystem(this.selectedSystem, this.selectedRegional, this.UId, this.RoleName).subscribe({
        next: (res: any) => {
          this.selectedFacility = null;
          this.SelectFacilityData = res.data;
        }
      })
    )
  }

  OnChangeRegionalFilter() {
    this.subscription.push(
      this.mrsService.GetFacilityByRegional(this.selectedRegional, this.selectedSystem, this.UId, this.RoleName).subscribe({
        next: (res: any) => {
          this.selectedFacility = null;
          this.SelectFacilityData = res.data;
        }
      })
    )
  }

  checkEmptyFields() {
    this.data = {
      Take: this.rows,
      Skip: this.rows * this.pageNumber - this.rows,
      Sort: {
        FieldName: this.sortCol,
        Order: this.sortOrder,
      },
      // searchString: this.searchField.trim(),
      PageNumber: this.pageNumber,
      serviceType: [],
      roleIDs: [],
      Filters: [
        {
          FieldName: 'qps',
          Value: this.selectedQPS.toString(),
        },
        {
          FieldName: 'date_type',
          Value: this.selectedDateType ? this.selectedDateType : 'Date of Consult',
        },
        {
          FieldName: 'action_type',
          Value: this.selectedActionType.toString(),
        },
        {
          FieldName: 'participated',
          Value: this.selectedParticipatesInRapidi.toString(),
        },
        {
          FieldName: 'start_date',
          Value: this.txtStartDate ? this.txtStartDate.toDateString() : this.txtStartDate,
        },
        {
          FieldName: 'end_date',
          Value: this.txtEndDate ? this.txtEndDate.toDateString() : this.txtEndDate,
        }
      ],
      data: {
        Facilities: this.selectedFacility,
        System: [],
        Regional: [],
        FilterType: ''
      }
    };
    let date = new Date().toDateString();
    if (this.selectedSystem > 0 || this.selectedRegional > 0 || this.selectedFacility.length > 0 || this.selectedQPS.length > 0 ||
      this.selectedActionType.length > 0 || this.selectedParticipatesInRapidi.length > 0 || this.txtStartDate.toDateString() !== date || this.txtEndDate.toDateString() !== date) {
      this.clearSearchBool = true;
    } else {
      this.clearSearchBool = false;
    }

    if (this.txtStartDate !== null && this.txtEndDate !== null) {
      let txtStartDate = new Date(this.txtStartDate);
      let txtEndDate = new Date(this.txtEndDate);
      txtStartDate.setHours(0, 0, 0, 0);
      txtEndDate.setHours(0, 0, 0, 0);
      if (txtStartDate > txtEndDate) {
        this.dateRangeBool = true;
      } else {
        this.dateRangeBool = false;
      }
    }
  }

  GetMRSFollowUpReport() {
    this.checkEmptyFields();
    this.totalRecords = 0;
    if (!this.dateRangeBool) {
      this.showProgressSpinner = true;
      this.subscription.push(
        this.mrsService.GetMRSFollowUpReport(this.UId, this.RoleName, this.data).subscribe({
          next: (res: any) => {
            this.mrsData = [];
            if (res.data.length > 0) {
              this.dataForExcelBool = true;
              this.mrsData = res.data;
              // if(this.mrsData.length > 0){
              //   this.mrsData.map((val: any) => {
              //     const initialContactDate = new Date(val?.InitialContact);
              //     val.InitialContact = isNaN(initialContactDate.getTime()) ? 'Invalid Date' : this.datePipe.transform(initialContactDate, 'MM/dd/yyyy HH:mm:ss');

              //   });
              // }
              this.totalRecords = res.Total;
            } else {
              this.dataForExcelBool = false;

            }
            this.showProgressSpinner = false;
          },
          error: (err: any) => { },
        })
      );
    } else {
      if (this.dateRangeBool == true) {
        this.messageService.add({
          key: 'save',
          severity: 'error',
          summary: 'Please ',
          detail: 'End Date should be greater than Start Date.',
        });
        this.textEndColorBool = true;
        setTimeout(() => {
          this.textEndColorBool = false;
        }, 1000);
        return;
      }
    }
  }

  lazyLoadPageSchedules(event: any) {
    if (event !== undefined) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder = event.multiSortMeta == undefined || event.multiSortMeta[0].order == -1 ? 'DESC' : 'ASC';
      this.sortCol = event.multiSortMeta == undefined ? '' : event.multiSortMeta[0].field;
      this.GetMRSFollowUpReport();
    }
  }

  lazyLoadSortSchedules(event: any) {
    if (event !== undefined) {
      this.sortOrder = event.multisortmeta == undefined || event.multisortmeta[0].order == -1 ? 'DESC' : 'ASC';
      this.sortCol = event.multisortmeta == undefined ? '' : event.multisortmeta[0].field;
      this.mrsData = this.customSortArray(this.mrsData, this.sortCol, this.sortOrder);
    }
  }

  // Define a custom sorting function
  // customSortArray(array: any[], sortField: string, sortOrder: string) {
  //   return array.sort((a: any, b: any) => {
  //     let comparison = 0;
  //     // const valueA = sortField == 'InitialContact' ? new Date(a.InitialContact.split(' ')[0] + ' ' + a.InitialContact.split(' ')[1] + ' ' + a.InitialContact.split(' ')[2]) : a[sortField];
  //     // const valueB = sortField == 'InitialContact' ? new Date(b.InitialContact.split(' ')[0] + ' ' + b.InitialContact.split(' ')[1] + ' ' + b.InitialContact.split(' ')[2]) : b[sortField];
  //     const valueA = a[sortField];
  //     const valueB = b[sortField];
  //     if (valueA > valueB) {
  //       comparison = 1;
  //     } else if (valueA < valueB) {
  //       comparison = -1;
  //     }
  //     if (sortOrder === 'DESC') {
  //       comparison *= -1;
  //     }
  //     return comparison;
  //   });
  // }

  customSortArray(array: any[], sortField: string, sortOrder: string) {
    return array.sort((a: any, b: any) => {
      let comparison = 0;
      
      const valueA = a[sortField];
      const valueB = b[sortField];
  
      // Handling null values
      if (valueA === null && valueB === null) {
        return 0;
      } else if (valueA === null) {
        return sortOrder === 'ASC' ? 1 : -1;
      } else if (valueB === null) {
        return sortOrder === 'ASC' ? -1 : 1;
      }

      // Handling empty values
      if (valueA === '' && valueB === '') {
        return 0;
      } else if (valueA === '') {
        return sortOrder === 'ASC' ? 1 : -1;
      } else if (valueB === '') {
        return sortOrder === 'ASC' ? -1 : 1;
      }
  
      // Handling different data types
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        // Compare strings
        comparison = valueA.localeCompare(valueB);
      } else {
        // Compare other data types (numbers, dates, etc.)
        comparison = valueA - valueB;
      }
  
      // Apply sortOrder
      if (sortOrder === 'DESC') {
        comparison *= -1;
      }
  
      return comparison;
    });
  }
  

  ClearSearch() {
    this.clearSearchBool = false;
    if (this.selectedFacility.length > 0) {
      this.selectedFacility = [];
    }
    if (this.selectedQPS.length > 0) {
      this.selectedQPS = [];
    }
    this.selectedDateType = '';

    if (this.selectedActionType.length > 0) {
      this.selectedActionType = [];
    }
    this.txtStartDate = new Date();
    this.txtEndDate = new Date();
    if (this.selectedParticipatesInRapidi.length > 0) {
      this.selectedParticipatesInRapidi = [];
    }

    if (this.mrsData.length > 0) {
      this.dataForExcelBool = true;
    } else {
      this.dataForExcelBool = false;
    }

  }

  excelDownload(workbook: any, fileName: any) {
    workbook.xlsx.writeBuffer().then((data: any) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, fileName + '.xlsx');
    })
  }

  exportExcel() {
    this.exportExcelLoader = true;

    let newArray: any = [];
    let mrsData: any = [];

    if (this.mrsData.length > 0) {
      mrsData = this.mrsData;
      if (mrsData.length > 0) {
        mrsData.filter((obj: any) => {

          newArray.push({
            CaseNumber: obj.CaseNumber, DateofConsult: obj.DateofConsult, FacilityID: obj.FacilityID, Facility: obj.Facility,
            PatientName: obj.PatientName, DOB: obj.DOB, Age: obj.Age, Gender: obj.Gender, PhysicianId: obj.PhysicianId,
            Physician: obj.Physician, IdentificationType: obj.IdentificationType, Identification: obj.Identification, DoorToNeedle: obj.DoorToNeedle, Navigator: obj.Navigator, NightyDaysMRSValue: obj.NightyDaysMRSValue,
            PremorbidMRSValue: obj.PremorbidMRSValue, InitialContact1: obj.InitialContact1, ActionPremorbid1: obj.ActionPremorbid1,Comment1: obj.Comment1, InitialContact2: obj.InitialContact2, ActionPremorbid2: obj.ActionPremorbid2,Comment2: obj.Comment2, InitialContact3: obj.InitialContact3, ActionPremorbid3: obj.ActionPremorbid3,Comment3: obj.Comment3, InitialContact4: obj.InitialContact4, ActionPremorbid4: obj.ActionPremorbid4,Comment4: obj.Comment4,CurrentStatus: obj.CurrentStatus, CompletedBy: obj.CompletedBy, PatientSatisfactionScore: obj.PatientSatisfactionScore, Note: obj.Note, 
            PatientPhoneNumber: obj.PatientPhoneNumber
          });

        });
      }

      let dataForExcel: any = [];
      let workbook = new Workbook();
      let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
      worksheet.columns = [
        { header: 'CaseNumber', key: 'CaseNumber', width: 15 },
        { header: 'ConsultDate', key: 'ConsultDate', width: 15 },
        { header: 'Facility ID', key: 'Facility ID ', width: 15 },
        { header: 'Facility', key: 'Facility', width: 60 },
        { header: 'Patient Name', key: 'Patient Name', width: 25 },
        { header: 'DOB', key: 'DOB', width: 15 },
        { header: 'Age', key: 'Age', width: 10 },
        { header: 'Gender', key: 'Gender', width: 10 },
        { header: 'Phyician ID', key: 'Phyician ID', width: 15 },
        { header: 'Phyician', key: 'Phyician', width: 30 },
        { header: 'Identification Type', key: 'Identification Type', width: 25 },
        { header: 'Identification', key: 'Identification', width: 15 },
        { header: 'Arrival to needle time', key: 'Arrival to needle time', width: 25 },
        { header: 'Navigator', key: 'Navigator', width: 25 },
        { header: '90 days MRS', key: '90 days MRS', width: 20 },
        { header: 'Pre Morbid MRS', key: 'Pre Morbid MRS', width: 20 },
        { header: 'Initial Contact Date 1', key: 'Initial Contact Date 1', width: 25 },
        { header: 'Action 1', key: 'Action 1', width: 25 },
        { header: 'Comments 1', key: 'Comments 1', width: 25 },
        { header: 'Initial Contact Date 2', key: 'Initial Contact Date 2', width: 25 },
        { header: 'Action 2', key: 'Action 2', width: 25 },
        { header: 'Comments 2', key: 'Comments 2', width: 25 },
        { header: 'Initial Contact Date 3', key: 'Initial Contact Date 3', width: 25 },
        { header: 'Action 3', key: 'Action 3', width: 25 },
        { header: 'Comments 3', key: 'Comments 3', width: 25 },
        { header: 'Initial Contact Date 4', key: 'Initial Contact Date 4', width: 25 },
        { header: 'Action 4', key: 'Action 4', width: 25 },
        { header: 'Comments 4', key: 'Comments 4', width: 25 },
        { header: 'Current Status', key: 'Current Status', width: 25 },
        { header: 'Completed by', key: 'Completed by', width: 30 },
        { header: 'Patient Satisfaction Score', key: 'Patient Satisfaction Score', width: 30 },
        { header: 'Note', key: 'Note', width: 25 },
        { header: 'Patient Phone Number', key: 'Patient Phone Number', width: 35 }
      ]
      worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
        row.eachCell((cell, number) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '767C88' },
            bgColor: { argb: '' },

          }
          cell.font = {
            bold: true,
            color: { argb: 'FFFFFF' },
            size: 12,
          }
        })
      })
      newArray.forEach((element: any) => {
        element.Comments = element.Comments ? element.Comments.replace(/\n/g, '\n\n') : element.Comments;
        dataForExcel.push(Object.values(element))
      });
      worksheet.columns.forEach((column, index) => {
        if (column.header === 'Comments') { // Adjust according to your column header
          let maxCellLength = 0;
          worksheet.getColumn(index + 1).eachCell({ includeEmpty: true }, (cell) => {
            maxCellLength = Math.max(maxCellLength, cell.text.length);
          });
          column.width = maxCellLength + 2; // Add a buffer to the width
        }
      });
      dataForExcel.forEach((d: any) => {
        let row = worksheet.addRow(d);
      })
      this.excelDownload(workbook, "MRS Report");
      this.exportExcelLoader = false;
    }


  }
}
